import TipTapParagraph from '@tiptap/extension-paragraph'

export const Paragraph = TipTapParagraph.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "mb-4 text-lg editor-placeholder"
      },
    }
  },
})
